export enum ColumnDisplayType {
  text,
  routerLink,
  chipList,
  actionList,
  statusList,
  statusIcon,
  selectBox
}
